import React from 'react'
import { Link } from 'react-router-dom'
import pages from '../constants/pages'

function NotFound() {
    return (
        <div class="d-flex align-items-center justify-content-center vh-100">
            <div class="text-center">
                <h1 class="display-1 fw-bold">404</h1>
                <p class="fs-3"> <span class="text-danger">Oops!</span> Page not found.</p>
                <p class="lead">
                    The page you’re looking for doesn’t exist.
                </p>
                <Link to={pages.HOME} class="btn btn-primary">Go Back Home</Link>
            </div>
        </div>
    )
}

export default NotFound